/*
  Market-aware links.

  Links typed in full (https://smokai.com/pages/faq) or as bare paths (/pages/faq)
  are output exactly as written, so they drop the visitor's market prefix and send
  them to the NZ storefront – which also overwrites their saved market. Links picked
  from the resource list get the prefix from Shopify; this does the same for the rest.

  On a market with a prefix (e.g. /en-us), any link to this store without a prefix
  is rewritten to include the current one. NZ (no prefix) is left alone.

  Skips: other domains, links that already carry a market prefix, files, checkout,
  app proxies and other system paths, and anything marked data-market-link="off".
*/
(function () {
  var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/+$/, '');
  if (!root) return;

  var hosts = [location.hostname].concat(window.smMarketLinkHosts || []).map(function (h) {
    return String(h).toLowerCase();
  });

  // First path segment that looks like a market/locale prefix: /en-us, /en, /fr-ca
  var prefixed = /^\/[a-z]{2}(?:-[a-z0-9]{2,4})?(?:\/|$)/i;
  var system = /^\/(?:cdn|checkout|checkouts|cart\/c|apps|a|tools|services|admin|account\/login\/multipass|customer_authentication|customer_identity|s\/files|wpm[^/]*|web-pixels[^/]*|api|\.well-known|localization|sitemap[^/]*|robots\.txt)(?:\/|$|\.|\?)/i;
  var file = /\.[a-z0-9]{2,5}$/i;

  function localize(a) {
    if (!a || a.tagName !== 'A' || a.hasAttribute('download')) return;
    if (a.closest('[data-market-link="off"]')) return;

    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || /^(?:mailto|tel|sms|javascript):/i.test(raw)) return;

    var url;
    try {
      url = new URL(raw, location.href);
    } catch (e) {
      return;
    }
    if (!/^https?:$/.test(url.protocol)) return;
    if (hosts.indexOf(url.hostname.toLowerCase()) === -1) return;

    var path = url.pathname;
    if (path === root || path.indexOf(root + '/') === 0) return;
    if (prefixed.test(path) || system.test(path) || file.test(path)) return;

    var next = root + (path === '/' ? '' : path) + url.search + url.hash;
    if (next !== raw) a.setAttribute('href', next);
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'A') localize(node);
    var links = node.querySelectorAll ? node.querySelectorAll('a[href]') : [];
    for (var i = 0; i < links.length; i++) localize(links[i]);
  }

  scan(document.documentElement);

  // Drawers, mega menus, quick views, app widgets and anything else added later.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes') localize(m.target);
      else for (var j = 0; j < m.addedNodes.length; j++) scan(m.addedNodes[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

  // Last line of defence: fix the link at the moment it is used.
  ['click', 'auxclick', 'contextmenu'].forEach(function (type) {
    document.addEventListener(
      type,
      function (e) {
        var a = e.target && e.target.closest && e.target.closest('a[href]');
        if (a) localize(a);
      },
      true
    );
  });
})();
